import React, { createContext, useContext, useState, useEffect } from 'react';
import '../styles/pdv-themes.css';

const ThemeContext = createContext(null);

const THEMES = ['claro', 'azul'];
const DEFAULT_THEME = 'claro';

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    try {
      const saved = localStorage.getItem('sf_theme');
      return THEMES.includes(saved) ? saved : DEFAULT_THEME;
    } catch {
      return DEFAULT_THEME;
    }
  });

  // Aplica a classe theme-* no <body> para que TODA a aplicação reaja às variáveis CSS
  useEffect(() => {
    const body = document.body;
    THEMES.forEach((t) => body.classList.remove(`theme-${t}`));
    body.classList.add(`theme-${theme}`);
    try { localStorage.setItem('sf_theme', theme); } catch {}
  }, [theme]);

  const changeTheme = (t) => {
    if (THEMES.includes(t)) setTheme(t);
  };

  return (
    <ThemeContext.Provider value={{ theme, changeTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme deve ser usado dentro de ThemeProvider');
  return ctx;
};
